export default __webpack_public_path__ + "static/media/my-markit-inc-black.fd6f5b61.svg";